module.exports = __webpack_public_path__ + "img/programme2.e080bc38.png";